import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { CheckCircle2, X } from 'lucide-react'

export const ACTION_SUCCESS_MS = 2500

// Shared portal keeps confirmations outside edited panels and stacks concurrent actions.
let host = null
let users = 0
export function BottomLeftFeedback({ children }) {
  const [target, setTarget] = useState(null)
  useLayoutEffect(() => {
    if (!host?.isConnected) {
      host = document.createElement('div')
      host.dataset.actionFeedback = 'bottom-left'
      host.className = 'fixed bottom-5 left-5 z-[9999] flex max-w-[calc(100vw-2.5rem)] flex-col-reverse gap-2 pointer-events-none'
      document.body.appendChild(host)
    }
    const mountedHost = host
    users += 1
    setTarget(mountedHost)
    return () => {
      users -= 1
      if (!users) { mountedHost.remove(); if (host === mountedHost) host = null }
    }
  }, [])
  return target ? createPortal(<div className="pointer-events-auto">{children}</div>, target) : null
}

export default function ActionSuccessToast({ message, onDismiss, testId }) {
  const dismiss = useRef(onDismiss)
  dismiss.current = onDismiss
  const [expired, setExpired] = useState(false)
  useEffect(() => {
    setExpired(false)
    if (!message) return
    const timer = setTimeout(() => { setExpired(true); dismiss.current?.() }, ACTION_SUCCESS_MS)
    return () => clearTimeout(timer)
  }, [message])
  if (!message || expired) return null
  return <BottomLeftFeedback>
    <div role="status" data-tone="success" data-testid={testId || 'action-success-toast'} className="animate-notification-toast-in flex items-center gap-3 rounded-lg border border-forest/30 bg-canvas px-4 py-3 text-xs text-ink shadow-xl">
      <CheckCircle2 size={16} className="shrink-0 text-forest" />
      <span className="whitespace-pre-wrap">{message}</span>
      <button type="button" aria-label="Dismiss success notification" onClick={() => { setExpired(true); dismiss.current?.() }} className="rounded p-1 text-inkMuted hover:text-ink"><X size={12} /></button>
    </div>
  </BottomLeftFeedback>
}
